"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.querybAsset = void 0;
const __1 = require("..");
const __2 = require("../..");
const address_provider_1 = require("../../address-provider");
const queryAddressProvider = (lcd, addressProvider, asset) => __awaiter(void 0, void 0, void 0, function* () {
    // dynamically discover the contract addresses for the bAsset collateral
    const { collateral_token, custody_contract } = asset;
    const { minter } = yield (0, __1.queryTokenMinter)({
        lcd,
        token_address: collateral_token,
    })(addressProvider);
    const { reward_contract } = yield (0, __1.queryCustodyConfig)({
        lcd,
        custody_contract_address: custody_contract,
    })(addressProvider);
    const { wormhole_token_address } = yield (0, __1.querybAssetConverterConfig)({
        lcd,
        converter_contract_address: minter,
    })(addressProvider);
    return new address_provider_1.BAssetAddressProviderImpl({
        token: collateral_token,
        custody: custody_contract,
        reward: reward_contract,
        converter: minter,
        wormhole: wormhole_token_address,
    });
});
const queryWormholeTokenDecimals = (lcd, addressProvider, wormholeTokenAddress) => __awaiter(void 0, void 0, void 0, function* () {
    const token = yield (0, __1.queryTokenInfo)({
        lcd,
        token_address: wormholeTokenAddress,
    })(addressProvider);
    return token === null || token === void 0 ? void 0 : token.decimals;
});
const querybAssetWhitelistElem = (lcd, addressProvider, asset) => __awaiter(void 0, void 0, void 0, function* () {
    // need to perform a lookup on the elem first
    if ('market' in asset) {
        const { symbol, market } = asset;
        const response = yield (0, __1.queryOverseerWhitelist)({
            lcd,
            market,
        })(addressProvider);
        const index = response.elems.findIndex((elem) => elem.symbol === symbol);
        return index < 0 ? undefined : response.elems[index];
    }
    return asset;
});
const querybAsset = ({ lcd, asset }) => (addressProvider) => __awaiter(void 0, void 0, void 0, function* () {
    const whitelistElem = yield querybAssetWhitelistElem(lcd, addressProvider, asset);
    if (whitelistElem === undefined) {
        return undefined;
    }
    const bAssetAddressProvider = yield queryAddressProvider(lcd, addressProvider, whitelistElem);
    if (bAssetAddressProvider.wormhole()) {
        const wormholeTokenDecimals = yield queryWormholeTokenDecimals(lcd, addressProvider, bAssetAddressProvider.wormhole());
        return new __2.BAsset({
            lcd,
            addressProvider,
            bAssetAddressProvider,
            wormhole: { decimals: wormholeTokenDecimals },
        });
    }
    return new __2.BAsset({ lcd, addressProvider, bAssetAddressProvider });
});
exports.querybAsset = querybAsset;
//# sourceMappingURL=query-basset.js.map